import React from 'react'
import CycleCountPage from './CycleCountPage'

const CycleCount = () => {
  return (
    <div>
      <CycleCountPage />
    </div>
  )
}

export default CycleCount